export const iframeSearcher: (iframeId: string, childId?: string) => Promise<HTMLElement> = (
  iframeId: string,
  childId?: string
) => {
  return new Promise(res => {
    const searchInterval = setInterval(() => {
      const iframe = document.getElementById(iframeId);
      if (iframe) {
        const body = (iframe as any).contentWindow.document.getElementsByTagName('body') as HTMLCollection;
        if (!childId) {
          res(body[0] as HTMLElement);
          clearInterval(searchInterval);
          return;
        }
        const divs = body[0].getElementsByTagName('div');
        for (let i = 0; i < divs.length; ++i) {
          if (divs[i].id === childId) {
            res(divs[i]);
            clearInterval(searchInterval);
          }
        }
      }
    }, 1000);
  });
};

export const disableInteractions = (element: HTMLElement) => {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(() => {
      if (element.style.cssText !== 'pointer-events: none;') {
        element.style.cssText = 'pointer-events: none';
      }
    });
  });
  element.style.cssText = 'pointer-events: none';
  observer.observe(element, { attributes: true, attributeFilter: ['style'] });
};

export const disableIframeContent = async (iframeId: string, childId: string) => {
  const previewBodyChild = await iframeSearcher(iframeId, childId);
  disableInteractions(previewBodyChild);
};
